<template>
  <div>
    <!-- <Preloader></Preloader> -->
    <!-- main wrapper start -->
    <div class="pa-main-wrapper">
      <Header :goto="goto" :myHide="myHide" @redirect="goDownload()"></Header>
      <!-- about start -->
      <div class="pa-about spacer-top spacer-bottom">
          <div class="hg-about">
              <p>Hello-Get，为您的文件提供15分钟短时存储服务</p>
          </div>
          <div class="container">
              <div class="row">
                  <div class="col-lg-5">
                      <div class="pa-about-content">
                          <div class="pa-heading hg-upheader">
                              <el-upload
                                class="upload-demo"
                                ref="upload"
                                action
                                name="up_file"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :before-remove="beforeRemove"
                                :multiple="multiple"
                                :before-upload="handleBefore"
                                :file-list="fileList"
                                :on-change="handleChange"
                                :http-request="uploadFile"
                                :on-success="handleSuccess"
                                :on-error="handleError">
                                <button type="button" class="pa-btn"><i class="el-icon-top"></i> 上传文件</button>
                              </el-upload>
                              <div v-show="progressFlag">
                                  <el-progress :percentage="progressPercent" :status="upStatus"></el-progress>
                              </div>
                              <h1>选择一个文件，开始上传</h1>
                              <h5 class="down-title">使用条款</h5>
                          </div>
                          <p>1. 文件最大50MB。</p>
                          <p>2. 禁止上传违法文件，不允许网站程序文件。</p>
                          <p>3. 请遵守互联网使用的中国法律与你当地法律。</p>
                          <p>4. 文件下载全网开放，本站不对任何损失负责。</p>
                          <p>5. 上传即表示同意上述条款，本站保留一切权利。</p>
                      </div>
                  </div>
                  <div class="col-lg-7">
                      <div class="down-link">
                          <div class="down-title">文件下载链接</div>
                          <input id="link-content" @focus="focus()">
                      </div>
                      <div class="down-title">扫二维码下载</div>
                      <div class="myflex">
                        <div class="qrcode-bg">
                            <img class="down-qrcode hide" alt="qrcode" />
                        </div>
                        <div class="hide countdown-box flex-center">
                            <h1>{{countdown}}</h1>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- about end -->
      <!-- how it works start -->
      <div class="pa-counter spacer-top spacer-bottom">
          <div class="container">
              <div class="pa-heading hg-center">
                  <h1>使用流程</h1>
                  <div id="hg-workflow">
                      <h5>1. &ensp;上传文件，获得下载链接和二维码。</h5>
                      <h5>2. &ensp;分享链接/二维码，下载文件。</h5>
                      <h5>3. &ensp;15分钟到期，文件永久删除。</h5>
                  </div>
              </div>
          </div>
      </div>
      <!-- how it works end -->
      <Copyright></Copyright>
    </div>
  </div>
</template>

<script>
import jquery from 'jquery'
import * as bootstrap from 'bootstrap'
import * as SmoothScroll from 'SmoothScroll'
import * as custom from 'custom'

import Preloader from '../../components/Preloader'
import Header from '../../components/Header'
import Copyright from '../../components/Copyright'
import FileUrl from '../../api/file.api'
import Routes from '../routes'
import Utils from '../../utils/utils'

export default {
  name: 'Index',
  components: {Preloader, Header, Copyright},
  data () {
    return {
      goto: '去下载',
      myHide: true,
      multiple: false,
      fid: '',
      fileList: [],
      progressFlag: false,  //进度条初始值隐藏
      progressPercent: 0,   //进度条初始值,
      upStatus: null,       //进度条状态值
      countdown: '',
      timer: null
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.progressFlag = false
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      //return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleSuccess(response, file, fileList) {
      //console.log(response)
      if (response.status == 1) {
        this.$message.warning(response.error)
        file.status = 'error'
        return
      }
      if (response.status == 0) {
        file.status = 'success'
      }
    },
    handleError(err,file,fileList) {
      console.log('got error')
      this.$message.warning(err)
    },
    handleBefore(file) {
      //清空旧数据
      if($('#link-content').val().length > 0) {
        $('#link-content').val('')
        $('.down-qrcode').hide()
      }
      if(file.size > 1024*1024*50) {
        this.$message.warning(`文件大小超过50M`)
        return false
      }
    },
    handleChange(file,fileList) {
      this.fileList = [file]
      this.progressPercent = 0
      this.progressFlag = false
      this.upStatus = null
      //隐藏倒计时
      $('.countdown-box').hide()
      //隐藏去下载链接
      this.myHide = true
      //清除timer
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    uploadFile(args) {
      let upData = new FormData()
      upData.append("up_file", args.file)
      upData.append("uid", args.file.uid)

      //显示上传进度
      this.progressFlag = true
      this.upStatus = null

      this.$api.upload(FileUrl.upload, upData, progressEvent => {
        this.progressPercent = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
      }, r => {
        this.$message({
         type: 'success',
         message: '上传成功'
        })
        // 进度条成功
        this.upStatus = 'success'
        // 设置下载链接
        $('#link-content').val(r.data.down_url)
        // 设置二维码图片
        $('.down-qrcode').attr('src', r.data.qrcode_path)
        $('.down-qrcode').show()
        // 设置fid
        this.fid = r.data.down_url.substr(r.data.down_url.lastIndexOf("/")+1)
        // 设置15分钟倒计时
        this.countDownInMinSec(900)
        // 显示倒计时
        $('.countdown-box').show()
        // 显示去下载页链接
        this.myHide = false
        // 清空文件列表
        this.fileList = []
        // 隐藏进度条
        this.progressFlag = false
      }, r => {
        if (r.status === 1) {
          this.$message({
           type: 'error',
           message: r.error
          })
          // 进度条警告状态
          this.upStatus = 'warning'
          // 不清空文件列表
          //this.$refs['upload'].clearFiles()
          // 保留进度条
          //this.progressFlag = false
        }
      })
    },
    focus() {
      let thisInput = $('#link-content')
      if (thisInput.val().length > 10) {
        //选中input中的内容
        thisInput.select()
      }
    },
    goDownload() {
      if(this.fid.length > 0) {
        this.$router.push('/get/'+this.fid)
      }
    },
    countDownInMinSec(totalSeconds) {
      let that = this
      var t = totalSeconds

      function countDown() {
          t--
          if (t <= 0) {
              clearInterval(that.timer)
              that.countdown = '文件已过期'
              //隐藏去下载链接
              that.myHide = true
              return false
          }
          that.countdown = Utils.formatSeconds(t)
      }
      that.timer = setInterval(countDown,1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hide {
    display: none;
  }
  .pa-about-content p {
    margin-bottom: 0.5rem;
  }
  .myflex {
    display: flex;
  }
  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue